<div class="container-fluid">
  <div class="authentication-main">
    <div class="row">
      <div class="col-md-12 p-0">
        <div class="auth-innerright">
          <div class="reset-password-box">
            <div class="text-center"><img src="assets/images/enplace_logo.png"
                alt></div>
            <div class="card mt-4 mb-0">
              <h4>Reset Your Password</h4>
              <p>A recovery email will be sent with instructions to reset your
                password.</p>
              <form [formGroup]="forgotPasswordForm" class="theme-form">
                <div class="form-group">
                  <label class="col-form-label">Enter your email:</label>
                  <div
                    class="d-flex justify-content-between align-items-start">
                    <div class="flex-grow-1 me-3">
                      <input class="form-control m-0" type="email"
                        formControlName="email">
                      <span
                        *ngIf="checkErrors && getFormControl('email')!.errors?.['required']"
                        class="text-danger">Email is
                        required.</span>
                      <span
                        *ngIf="getFormControl('email')!.value != '' && !getFormControl('email')!.value?.match(validEmailRegex)"
                        class="block text-danger">A valid email is
                        required.</span>
                    </div>
                    <div>
                      <button class="btn btn-primary m-0"
                        (click)="recoveryPassword()">Send recovery
                        email</button>
                    </div>
                  </div>
                  <div *ngIf="isLoading"
                    class="d-flex justify-content-center">
                    <div class="loader-box">
                      <div class="loader">
                        <div
                          class="line bg-primary"></div>
                        <div
                          class="line bg-primary"></div>
                        <div
                          class="line bg-primary"></div>
                        <div
                          class="line bg-primary"></div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-center">
                    <p *ngIf="showSentMessage"
                      class="mt-2 text-center text-success">The recovery email
                      has been sent. Please check your inbox and follow the
                      instructions to update your password.</p>
                    <p *ngIf="showMessageNotSent"
                      class="mt-2 text-center text-danger">A problem occurred
                      while trying to send the recovery message. Please try
                      again later.</p>
                  </div>
                </div>
              </form>
              <div class="d-flex">
                <div class="mt-2"><a
                    routerLink="/authentication/login">Back to Login</a></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>